import { NgModule } from "@angular/core";
import { ThemeModule } from "../../@theme/theme.module";
import { SproLibModule } from "../../sproLib/spro/spro-lib.module";
import { TranslateModule } from "@ngx-translate/core";
import { cls_login } from "./login.component";

@NgModule({
  imports: [ThemeModule, TranslateModule, SproLibModule],
  declarations: [cls_login]
})
export class AppLoginModule {}



// WEBPACK FOOTER //
// C:/spro/Workspaces/VisualCode/Ecoltex2/src/app/pages/login/login.module.ts